import React from 'react'
import Badge from '../Badge'

interface Props {
   title: string,
   isHighlighted?: boolean,
   img?: {
      src?: string,
      srcMobile?: string,
      alt?: string,
   },
   url: string,
   badges?: {
      insights?: boolean,
      news?: boolean,
   },
   customBadges?: string[],
   key?: number,
}

export default function ArticleCard(props: Props) {
   const { title, isHighlighted, img, url, badges, customBadges } = props

   return (
      <>
         {isHighlighted ? (
            <a className='grid-row article-card article-card--highlight' href={url}>
               {
                  img.src &&
                  <figure className='article-card__image c-md-8'>
                     <picture>
                        <source
                           media="(min-width: 575px)"
                           srcSet={img.src}
                        />
                        <source
                           media="(max-width: 574px)"
                           srcSet={img.srcMobile}
                        />
                        <img
                           src={img.src}
                           alt={img.alt || title}
                           loading='lazy'
                        />
                     </picture>
                  </figure>
               }
               <div className="article-card__content c-md-4">
                  {badges &&
                     <div className="article-card__badges">
                        {badges && <Badge {...badges}></Badge>}
                        {customBadges &&
                           customBadges.map((badge, index) => (
                              <Badge customBadge={[badge]} key={index}></Badge>
                           ))}
                     </div>
                  }
                  {title && <p className='title'>{title}</p>}
               </div>
            </a>
         ) : (
            <a href={url} className="article-card">
               <figure className='article-card__image'>
                  {img.src && <img src={img.src} alt={img.alt || title} loading='lazy' />}
               </figure>
               <div className="article-card__content">
                  {badges &&
                     <div className="article-card__badges">
                        {badges && <Badge {...badges}></Badge>}
                        {customBadges &&
                           customBadges.map((badge, index) => (
                              <Badge customBadge={[badge]} key={index}></Badge>
                           ))}
                     </div>
                  }
                  <p className='title'>{title}</p>
               </div>
            </a>
         )}
      </>
   )
}